<template>
  <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide 
        v-for="(img, index) in data.images" 
        :key="index"
    ><img :src="imageUrl + img"></swiper-slide>
    <div class="swiper-pagination" slot="pagination"></div>
  </swiper>
</template>
 
<script>
  export default {
    name: 'carrousel',

    props: {
        data: Object
    },
    data() {
      return {
        swiperOptions: {
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction'
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 'auto',
            spaceBetween: 10,
            autoHeight: true
        },
        imageUrl: process.env.VUE_APP_BASE_FILES_URL
      }
    },
    computed: {
      swiper() {
        return this.$refs.mySwiper.$swiper
      }
    },
    mounted() {
        console.log(this.data)
      console.log('Current Swiper instance object', this.swiper)
      this.swiper.slideTo(3, 1000, false)
    }
  }
</script> 